import { useQuery } from '@tanstack/react-query';
import { api } from '../../../shared/api.js';

export function useProducts(filters = {}) {
  const params = {};
  if (filters.q) params.q = filters.q;
  if (filters.warehouseId) params.warehouseId = filters.warehouseId;
  if (filters.categoryId) params.categoryId = filters.categoryId;
  if (filters.type) params.type = filters.type;
  if (typeof filters.lowStock === 'boolean') params.lowStock = filters.lowStock;
  if (typeof filters.active === 'boolean') params.active = filters.active;
  params.page = filters.page || 1;
  params.limit = filters.limit || 20;

  return useQuery({
    queryKey: ['catalog', 'products', params],
    queryFn: async () => {
      const { data } = await api.get('/catalog/products', { params });
      return {
        items: data?.items || [],
        total: data?.total || 0,
        page: data?.page || 1,
        pages: data?.pages || 1,
        limit: data?.limit || 20
      };
    },
    keepPreviousData: true,
    staleTime: 15_000
  });
}

export function useProduct(id) {
  return useQuery({
    queryKey: ['catalog', 'product', id],
    enabled: !!id,
    queryFn: async () => {
      const { data } = await api.get(`/catalog/products/${id}`);
      return data;
    }
  });
}
